export interface SecurityProfile {
    [entity: string]: RoleEntityPermissions
}

export interface RoleEntityPermissions {
    [permission: string]: boolean
}

export interface SecurityProfileResponseEntity {
    entityId: string,
    entityName: string,
    permissions: SecurityProfileResponsePermission[]
}

export interface SecurityProfileResponsePermission {
    permissionId: string,
    name: string
}